import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';
import useProject from 'src/shared/hooks/useProject';

const useEcologyHubAnalytics = () => {
    const { currentProjectDetails } = useProject();

    const sendTrackEvent = (ga: { action: string; category?: string; app: string }) => {
        analyticsTracking.trackEvent({
            ...ga,
            project: currentProjectDetails?.projectName,
            category: ga.category || 'ecology-hub',
        });
    };

    const trackSpeciesTrendsDownloadImageClick = () => {
        sendTrackEvent({
            app: AppName.SPECIES_TRENDS,
            action: `species_trends_download_image_click`,
        });
    };

    const trackHabitatTrendsDownloadImageClick = () => {
        sendTrackEvent({
            app: AppName.HABITAT_TRENDS,
            action: `habitat_trends_download_image_click`,
        });
    };

    const trackStatisticalComparisonDownloadImageClick = () => {
        sendTrackEvent({
            app: AppName.STATISTICAL_COMPARISON,
            action: `statistical_comparison_download_image_click`,
        });
    };

    return {
        sendTrackEvent,
        trackSpeciesTrendsDownloadImageClick,
        trackHabitatTrendsDownloadImageClick,
        trackStatisticalComparisonDownloadImageClick,
    };
};

export default useEcologyHubAnalytics;
